import React, { useRef, useCallback, useState, useContext, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormButtons from '../form-control-buttons/FormButtons/FormButtons';
import UserContext from '../../../common/utils/getContext';
import FormSwitcher from '../FormSwitcher';
import AddedComponents from '../AddedComponents';
import { sendFormDataFunc } from '../utils/formUtils';
import css from './FormComponent.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../common/utils/styles';

const FormComponent = ({
    data,
    funcs = {},
    formName = 'form',
    formStyles = {},
    sendData,
    add,
    buttons,
    setFormDataMain,
    formDataMain,
    buttonNotShow,
    groupFormDataError,
    message,
    customData = {},
    captcha,
    components,
    okButtonLoader = false
}) => {
    const { userToken, setAlertData, lang, localization } = useContext(UserContext);
    const addedTop = useMemo(() => add && add.filter((item) => item.position === 'top'), [add]);
    const addedMiddle = useMemo(() => add && add.filter((item) => item.position === 'middle'), [add]);
    const addedBottom = useMemo(() => add && add.filter((item) => item.position !== 'top' && item.position !== 'middle'), [add]);
    const getFormData = useMemo(
        () =>
            data && data.length
                ? data.reduce((accum, item) => {
                      if (item.disabled !== true) {
                          if (item.value || item.value === null) accum[item.attribute] = item.value;
                          else accum[item.attribute] = null;
                      }
                      return accum;
                  }, {})
                : {},
        [data]
    );
    const formData = useRef(getFormData);

    const [allowedSend, setAllowedSend] = useState(true);
    const [requestLoading, setRequestLoading] = useState(false);

    const [fieldsErr, setFieldsErr] = useState(groupFormDataError || {});
    useEffect(() => {
        if (groupFormDataError) {
            setFieldsErr(groupFormDataError);
        } else {
            setFieldsErr({});
        }
    }, [groupFormDataError]);
    const setFormData = useCallback(
        (key, val, ...args) => {
            if (setFormDataMain) {
                return setFormDataMain(key, typeof val === 'string' && val.length === 0 ? null : val, ...args);
            }
            return (formData.current[key] = typeof val === 'string' && val.length === 0 ? null : val);
        },
        [formData, setFormDataMain]
    );
    const sendFormData = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            sendFormDataFunc(
                formDataMain || formData.current,
                allowedSend,
                funcs,
                sendData,
                setAllowedSend,
                setFieldsErr,
                setAlertData,
                userToken,
                lang,
                message,
                localization?.currency,
                setRequestLoading,
                okButtonLoader
            );
        },
        [
            localization?.currency,
            formDataMain,
            allowedSend,
            funcs,
            sendData,
            setAlertData,
            userToken,
            lang,
            message,
            okButtonLoader
        ]
    );
    const { stylers, classes } = generateCompStylers(customData);
    if (!(data && Array.isArray(data) && data.length)) return null;
    return (
        <form
            className={classnames(css.form, classes.stylesForm)}
            style={stylers.stylesForm}
            autoComplete='off'
            onSubmit={sendFormData}
            name={formName}
            {...customData?.customFormProps}
        >
            {!!addedTop && !!addedTop.length && <AddedComponents add={addedTop} />}
            <div style={stylers?.fieldsWrapper} className={classes?.fieldsWrapper}>
                <FormSwitcher
                    data={data}
                    formName={formName}
                    funcs={funcs}
                    formStyles={formStyles}
                    formData={formDataMain || formData.current}
                    fieldsErr={fieldsErr}
                    customData={customData}
                    sendFormData={setFormDataMain || sendFormData}
                    message={message}
                    setFormData={setFormData}
                    captchaData={captcha}
                />
            </div>
            {!!addedMiddle && !!addedMiddle.length && <AddedComponents add={addedMiddle} />}
            {components?.beforeButtons && React.isValidElement(components?.beforeButtons) ? components?.beforeButtons : null}
            {buttonNotShow ? null : (
                <FormButtons
                    formName={formName}
                    buttons={buttons}
                    sendFormData={sendFormData}
                    customFormButton={customData?.customFormButton}
                    requestLoading={requestLoading}
                />
            )}
            {!!addedBottom && !!addedBottom.length && <AddedComponents add={addedBottom} />}
        </form>
    );
};
FormComponent.propTypes = {
    data: PropTypes.array,
    funcs: PropTypes.object,
    formName: PropTypes.string,
    formStyles: PropTypes.object,
    sendData: PropTypes.object,
    styles: PropTypes.object,
    add: PropTypes.array,
    buttons: PropTypes.array,
    formDataMain: PropTypes.object,
    setFormDataMain: PropTypes.func,
    buttonNotShow: PropTypes.bool,
    groupFormDataError: PropTypes.object,
    message: PropTypes.object,
    customData: PropTypes.object
};
export default FormComponent;
